import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ICardComponent } from '../../ICardComponent';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonData } from '../../../_infrastructure/CommonData/CommonDataResolver';
import { NgForm, ControlContainer } from '@angular/forms';
import { WorkflowComponent } from '../../workflow.component';
import DateHelpers from '../../../_infrastructure/DateHelpers';

@Component({
    selector: 'subscriber-identification',
    templateUrl: './subscriber-identification.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false
})
export class SubscriberIdentificationComponent implements OnInit, OnDestroy, ICardComponent {
  public cardData: models.SubscriberIdentificationVM = {} as models.SubscriberIdentificationVM;
  public cardConfiguration: models.CardVM;
  public isWorkflowOnSubscriber: boolean = false;

  @CommonData(DomainCodes.domains)
  public domains: models.DimensionVM[];
  @CommonData(DomainCodes.subscriberType)
  public subscriberTypes: models.DimensionVM[];
  @CommonData(DomainCodes.nationality)
  public nationalities: models.DimensionVM[];
  @CommonData(DomainCodes.genders)
  public genders: models.DimensionVM[];
  @CommonData(DomainCodes.identificationType)
  public documentTypes: models.DimensionVM[];
  @CommonData(DomainCodes.martialStatus)
  public maritalStatuses: models.DimensionVM[];
  public disabilityOptions = [
    {
      description: 'Permanente',
      value: 'P'
    },
    {
      description: 'Temporária',
      value: 'T'
    },
    {
      description: 'Não deficiente',
      value: 'N'
    }];

  public parentWorkflow: WorkflowComponent;
  public certifiedData;
  public taxServiceValues = [];
  public maritalStatus = [];
  public voluntary: boolean;
  public taxServiceFound;

  constructor(private http: HttpClient, private activeRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    if (this.isVersion2()) {
      
      this.voluntary = this.isVoluntary();
      if (this.parentWorkflow.workflowInstance.formData.StepCertification !== undefined) {
        this.certifiedData = this.parentWorkflow.workflowInstance.formData.StepCertification;

        //this.cardData.disability = this.parentWorkflow.workflowInstance.formData['StepSubscriberInfo']['SubscriberIdentification']['disability'];
        if (this.certifiedData.identificationData.maritalStatusCert)
          this.cardData.maritalStatusCode = this.certifiedData?.identificationData?.maritalStatusCert;

      }

      for (let i = 0; i < this.parentWorkflow.workflowDropdowns.options.length; i++) {
        if (this.parentWorkflow.workflowDropdowns.options[i].dropdown === 'DropdownTaxOffice') {
          this.taxServiceValues.push(this.parentWorkflow.workflowDropdowns.options[i]);
        }
        if (this.parentWorkflow.workflowDropdowns.options[i].dropdown === 'dropListMaritalStatus') {
          //if (this.certifiedData.identificationData.idenCertification === 'S' && this.parentWorkflow.workflowDropdowns.options[i].description !== 'UF') continue;
          //else this.maritalStatus.push(this.parentWorkflow.workflowDropdowns.options[i]);
          this.maritalStatus.push(this.parentWorkflow.workflowDropdowns.options[i]);
        }
      }
    }
  }

  ngOnDestroy(): void {
  }

  ngDoCheck(): void {
    if (this.isVersion2()) {
      //Needs to be done in DoCheck because of step data being received asyncrously
      if (this.parentWorkflow.workflowInstance.formData.StepCertification !== undefined) {
        this.certifiedData = this.parentWorkflow.workflowInstance.formData.StepCertification;
      }
    }
  }

  isVersion2() {
    let result = false;
    if (this.parentWorkflow.workflowInstance.formData['Version']?.toString() === '2') {
      result = true;
    }
    return result;
  }

  disableMaritalStatusOptions(value: string) {
    if (this.certifiedData.identificationData.idenCertification === 'S' && value !== 'UF')
      return true;
    else
      return false;
  }

  onTaxServiceCodeChanged() {
    let matchFound = false;
    if (this.cardData.taxServiceCode1.length === 4) {
      let inputTaxServCode = parseInt(this.cardData.taxServiceCode1);
      for (let i = 0; i < this.taxServiceValues.length; i++) {
        if (inputTaxServCode === parseInt(this.taxServiceValues[i].value)) {
          this.cardData.taxServiceCode2 = this.taxServiceValues[i].description;
          matchFound = true;
          this.taxServiceFound = true;
          break;
        }
      }
    }
    if (!matchFound) {
      this.cardData.taxServiceCode2 = undefined;
      this.taxServiceFound = false;
      if (this.cardData.taxServiceCode1 === '')
        this.taxServiceFound = undefined;
    }
  }

  isWorkflowCompulsoryAndOnService(): boolean {
    let isService = !this.isWorkflowOnSubscriber;
    let isCompulsory = !this.isVoluntary();

    return isService && isCompulsory;
  }

  isVoluntary(): boolean {
    let result = false;
    let voluntaryFundaments = ['PEDI001A', 'PEDI001B', 'PEDI001C', 'PEDI001D', 'PEDI001L', 'PEDI001F', 'PEDI001H', 'PEDI001I', 'PEDI001K', 'PEDI001O', 'PEDI001P', 'PEDI001S', 'PEDI001T', 'PEDI001V', 'PEDI001X', 'PEDI001Y', 'PEDI001Z', 'PEDI001AB', 'PEDI001AC', 'PEDI001AD'];
    if (voluntaryFundaments.indexOf(this.parentWorkflow['workflowInstance']['workflowCode']) >= 0) {
      result = true;
    }

    return result;
  }

  formatDate(event: any) {
    DateHelpers.formatDateGeneral(event);
  }

  onlyNumbers(event: any) {
    DateHelpers.onlyNumbers(event);
  }
}
